/* ==========================================================================
   TOTE - CRO split test round 2 (T33-T39) behaviour
   Kopstorm CommV

   Mode mirroring
   --------------
   Each test ships a hidden gated marker [data-kv-test="TXX"]. When
   Intelligems reveals a marker, the matching class is mirrored onto the
   html element (kv-t33, kv-t34 ...) so the CSS in kv-tests-r2.css takes
   effect. Adding the class directly from Intelligems variant JS also works
   and survives AJAX rerenders, which is the recommended route.

   Only T34, T35 and T36 need behaviour. T33, T37, T38 and T39 are pure CSS.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__kvTestsR2Init) return;
  window.__kvTestsR2Init = true;

  var IDS = ['T33', 'T34', 'T35', 'T36', 'T37', 'T38', 'T39',
             'T40', 'T41', 'T42', 'T43', 'T44', 'T45', 'T46', 'T47', 'T48', 'T49', 'T50', 'T65'];
  var root = document.documentElement;

  /* ---- Mode mirroring ---------------------------------------------------- */
  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return true;
  }

  function syncModes() {
    var changed = false;
    for (var i = 0; i < IDS.length; i++) {
      var id = IDS[i];
      var cls = 'kv-' + id.toLowerCase();
      var marker = document.querySelector('.kv-r2-mode[data-kv-test="' + id + '"]');
      var on = isVisible(marker);
      /* Never turn a class off that Intelligems set directly on html. */
      if (on && !root.classList.contains(cls)) {
        root.classList.add(cls);
        changed = true;
      }
    }
    if (changed) boot();
  }

  /* ---- T34 / T35 - gallery ------------------------------------------------ */
  function galleries() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.product__media-list.swiper, .product__media-list.js-media-list, .product__media-list.js-media-list-mobile')
    );
  }

  function slidesOf(gallery) {
    var wrap = gallery.querySelector('.swiper-wrapper');
    if (!wrap) return [];
    return Array.prototype.slice.call(wrap.children).filter(function (n) {
      return n.classList && n.classList.contains('product__media-item');
    });
  }

  function goTo(gallery, index) {
    if (gallery.swiper && typeof gallery.swiper.slideTo === 'function') {
      gallery.swiper.slideTo(index);
      return true;
    }
    var bullets = gallery.querySelectorAll('.swiper-pagination .swiper-pagination-bullet');
    if (bullets && bullets[index]) {
      bullets[index].click();
      return true;
    }
    return false;
  }

  function step(gallery, dir) {
    var btn = gallery.querySelector(dir > 0 ? '.swiper-button-next' : '.swiper-button-prev');
    if (btn) {
      btn.click();
      return;
    }
    if (gallery.swiper) {
      if (dir > 0) gallery.swiper.slideNext();
      else gallery.swiper.slidePrev();
    }
  }

  function activeIndex(gallery, slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('swiper-slide-active')) return i;
    }
    if (gallery.swiper && typeof gallery.swiper.realIndex === 'number') return gallery.swiper.realIndex;
    return 0;
  }

  function buildGallery(gallery) {
    if (gallery.__kvR2) return;
    var slides = slidesOf(gallery);
    if (slides.length < 2) return;
    gallery.__kvR2 = true;

    /* Overlays must sit on the media list itself, not on the wrapper, or they
       stretch down over the theme's own thumbnail sublist. */
    var host = gallery;
    if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';

    /* Tap zones (T34) */
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'kv-r2-tap kv-r2-tap--prev';
    prev.setAttribute('aria-label', 'Previous image');
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'kv-r2-tap kv-r2-tap--next';
    next.setAttribute('aria-label', 'Next image');
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      step(gallery, -1);
    });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      step(gallery, 1);
    });
    host.appendChild(prev);
    host.appendChild(next);

    /* Counter (T34) */
    var count = document.createElement('div');
    count.className = 'kv-r2-count';
    count.innerHTML = '<span data-kv-r2-now>1</span><span>/</span><span data-kv-r2-total>' + slides.length + '</span>';
    host.appendChild(count);
    var nowEl = count.querySelector('[data-kv-r2-now]');

    /* Swipe hint (T34, mobile only, once per session) */
    if (!sessionStorage.getItem('kvR2Hint')) {
      var hint = document.createElement('div');
      hint.className = 'kv-r2-hint';
      hint.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg><span>Swipe for more photos</span>';
      host.appendChild(hint);
      window.setTimeout(function () {
        hint.classList.add('is-out');
      }, 2600);
      window.setTimeout(function () {
        if (hint.parentNode) hint.parentNode.removeChild(hint);
      }, 3200);
      try {
        sessionStorage.setItem('kvR2Hint', '1');
      } catch (err) {
        /* private mode, hint simply shows again */
      }
    }

    /* Thumbnail rail (T35) */
    var rail = document.createElement('ul');
    rail.className = 'kv-r2-rail';
    var items = [];
    slides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;
      var li = document.createElement('li');
      li.style.listStyle = 'none';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kv-r2-rail__item';
      btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
      var thumb = document.createElement('img');
      thumb.src = img.currentSrc || img.src || '';
      thumb.alt = '';
      thumb.loading = 'lazy';
      btn.appendChild(thumb);
      btn.addEventListener('click', function () {
        goTo(gallery, i);
      });
      li.appendChild(btn);
      rail.appendChild(li);
      items.push(btn);
    });
    /* The theme already renders a thumbnail sublist on some gallery types.
       T35 replaces it rather than stacking a second rail underneath: the CSS
       hides .product__media-sublist-outer whenever kv-t35 is active. */
    if (items.length > 1) {
      var railHost = gallery.closest('.product__media-list-wrapper') || gallery.parentNode || host;
      railHost.appendChild(rail);
    }

    function paint() {
      var idx = activeIndex(gallery, slides);
      if (nowEl) nowEl.textContent = String(idx + 1);
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle('is-active', i === idx);
      }
    }
    paint();

    var mo = new MutationObserver(paint);
    slides.forEach(function (slide) {
      mo.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
    if (gallery.swiper && typeof gallery.swiper.on === 'function') {
      gallery.swiper.on('slideChange', paint);
    }
  }



  /* ---- Bottom stack offset ----------------------------------------------
     The T25 mobile nav is fixed to the bottom of the viewport. Its height
     is measured rather than assumed, because it changes with the safe area
     inset and with the nav's own settings. Everything that docks above it
     reads --kv-r2-navh.
     ---------------------------------------------------------------------- */
  function measureNav() {
    var bar = document.querySelector('.kv-mnav:not(.kv-tt-gated) .kv-mnav__bar');
    var h = 0;
    if (bar) {
      var cs = window.getComputedStyle(bar);
      if (cs.display !== 'none' && cs.visibility !== 'hidden') {
        h = Math.round(bar.getBoundingClientRect().height);
      }
    }
    /* With no nav the bars still need to clear the home indicator. */
    root.style.setProperty('--kv-r2-navh', h > 0 ? h + 'px' : 'env(safe-area-inset-bottom, 0px)');
  }

  /* ---- T40 - Find your TOTE badge on the gallery -------------------------- */
  function finderRoot() {
    return document.querySelector('[data-kv-tote-finder]');
  }

  function openFinder() {
    var root = finderRoot();
    if (!root) return;
    /* The finder opens as an overlay, so the page must stay where it is. */
    var launch = root.querySelector('.kv-tote-finder__launcher button, .kv-tote-finder__launcher a, [data-kv-tf-start]');
    if (launch) launch.click();
  }

  function buildFinderBadge(gallery) {
    if (gallery.__kvR2Badge) return;
    if (!finderRoot()) return;
    gallery.__kvR2Badge = true;
    var cfg = document.querySelector('.kv-r2-modes');
    var label = (cfg && cfg.getAttribute('data-kv-r2-finder-label')) || 'Which bag fits you?';
    var badge = document.createElement('button');
    badge.type = 'button';
    badge.className = 'kv-r2-finder-badge';
    badge.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg><span>' + label + '</span>';
    badge.addEventListener('click', function (e) {
      e.preventDefault();
      openFinder();
    });
    gallery.appendChild(badge);
  }

  /* ---- T36 - sticky buy bar ---------------------------------------------- */
  function realSubmit() {
    return document.querySelector('.product__info-container product-form button[name="add"]')
      || document.querySelector('product-form button[name="add"]')
      || document.querySelector('button[name="add"].product-form__submit');
  }

  function priceText() {
    var wrap = document.querySelector('.product__info-container .price-wrapper');
    if (!wrap) return '';
    var sale = wrap.querySelector('.price__sale');
    var regular = wrap.querySelector('.price__regular');
    var source = sale && window.getComputedStyle(sale).display !== 'none' ? sale : regular || wrap;
    return source.textContent.replace(/\s+/g, ' ').trim();
  }

  function buildBuyBar() {
    var bar = document.querySelector('[data-kv-r2-buybar]');
    if (!bar || bar.__kvR2) return;
    var target = realSubmit();
    if (!target) return;
    bar.__kvR2 = true;

    var priceEl = bar.querySelector('[data-kv-r2-buybar-price]');
    var cta = bar.querySelector('[data-kv-r2-buybar-cta]');

    function refresh() {
      var t = priceText();
      if (priceEl && t && priceEl.textContent !== t) priceEl.textContent = t;
      if (cta) {
        var off = target.hasAttribute('disabled');
        if (off) cta.setAttribute('disabled', 'disabled');
        else cta.removeAttribute('disabled');
      }
    }
    refresh();

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var live = realSubmit();
        if (!live || live.hasAttribute('disabled')) return;
        live.click();
      });
    }

    var info = document.querySelector('.product__info-container');
    if (info) {
      new MutationObserver(refresh).observe(info, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'class']
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      ).observe(target);
    } else {
      bar.classList.add('is-visible');
    }
  }



  /* ---- Finder dialog branding -------------------------------------------
     Clones the header logo into the top left of the quiz overlay so the
     popup reads as TOTE rather than as a generic modal.
     ---------------------------------------------------------------------- */
  function brandFinder() {
    var panel = document.querySelector('[data-kv-tote-finder] .kv-tote-finder__panel');
    if (!panel || panel.querySelector('.kv-r2-tf-logo')) return;
    var source = document.querySelector('.header__heading-logo');
    if (!source) return;
    var holder = document.createElement('span');
    holder.className = 'kv-r2-tf-logo';
    var clone = source.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.setAttribute('alt', '');
    clone.setAttribute('loading', 'lazy');
    holder.appendChild(clone);
    panel.insertBefore(holder, panel.firstChild);
  }

  /* ---- Empty custom_liquid blocks ---------------------------------------
     Unused custom_liquid blocks render as a zero height div that still
     carries margin-bottom: 1.5rem, which is where the dead band between the
     thumbnails and the variant tabs comes from.
     ---------------------------------------------------------------------- */
  function collapseEmptyBlocks() {
    var nodes = document.querySelectorAll(
      '.product .custom-liquid, .product__info-container .custom-liquid, .product__info-container .product__text'
    );
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.hasAttribute('data-kv-r2-collapsed')) return;
      if (node.textContent.trim() === '' && node.children.length === 0) {
        node.setAttribute('data-kv-r2-collapsed', '');
      }
    });
  }

  /* ---- T47 - Title, rating and Klarna above the gallery (mobile) ---------
     Moves the identity and trust line above the photos and pulls the variant
     tabs straight under the gallery. Reversible: every moved node leaves a
     marker behind so desktop and the control state restore exactly.
     ---------------------------------------------------------------------- */
  var T47_MOVED = [];

  function t47Nodes() {
    var info = document.querySelector('.product__info-container');
    if (!info) return [];
    var out = [];
    var title = info.querySelector('.product__title__wrapper');
    if (title) out.push(title);
    var loox = info.querySelector('.loox-rating, [class*="loox-rating"]');
    if (loox) out.push(loox.closest('.shopify-block') || loox);
    var pay = info.querySelector('[data-kv-test="T05"], .kv-tt-pay');
    if (pay) out.push(pay.closest('.shopify-block') || pay);
    return out;
  }

  function t47Apply() {
    if (T47_MOVED.length) return;
    if (window.innerWidth >= 750) return;
    var media = document.querySelector('.product__media-wrapper');
    var info = document.querySelector('.product__info-container');
    if (!media || !info) return;

    var lead = document.createElement('div');
    lead.className = 'kv-r2-lead';
    media.parentNode.insertBefore(lead, media);
    /* Match the gallery's own inset exactly rather than guessing a value,
       so the title lines up with the left edge of the photo. */
    var pad = Math.max(
      0,
      Math.round(media.getBoundingClientRect().left - lead.parentNode.getBoundingClientRect().left)
    );
    lead.style.paddingLeft = pad + 'px';
    lead.style.paddingRight = pad + 'px';

    t47Nodes().forEach(function (node) {
      var mark = document.createComment('kv-r2-lead');
      node.parentNode.insertBefore(mark, node);
      T47_MOVED.push({ node: node, mark: mark });
      lead.appendChild(node);
    });

    /* Tabs sit straight under the gallery, so they lead the info column. */
    var tabs = info.querySelector('.kv-variant-tabs-outer');
    if (tabs) {
      var tabMark = document.createComment('kv-r2-tabs');
      tabs.parentNode.insertBefore(tabMark, tabs);
      T47_MOVED.push({ node: tabs, mark: tabMark });
      var column = info.querySelector('.product__info-column') || info;
      column.insertBefore(tabs, column.firstChild);
    }
  }

  function t47Reset() {
    if (!T47_MOVED.length) return;
    T47_MOVED.forEach(function (entry) {
      if (entry.mark.parentNode) entry.mark.parentNode.insertBefore(entry.node, entry.mark);
      if (entry.mark.parentNode) entry.mark.parentNode.removeChild(entry.mark);
    });
    T47_MOVED = [];
    var lead = document.querySelector('.kv-r2-lead');
    if (lead && lead.parentNode) lead.parentNode.removeChild(lead);
  }

  function t47Sync() {
    if (root.classList.contains('kv-t47') && window.innerWidth < 750) t47Apply();
    else t47Reset();
  }


  /* ---- PDP block order API (T48-T50 and Intelligems custom orders) --------
     window.kvPdpOrder(['tabs','price','buy'])  moves those blocks, in that
     order, to the top of the product info column. Anything not listed keeps
     its original position underneath. window.kvPdpReset() puts everything
     back, so an Intelligems variant can be switched off cleanly.

     Keys: title, rating, klarna, price, tabs, swatches, inventory,
           shipping, discount, bundle, buy, returns, payments
     ---------------------------------------------------------------------- */
  var PDP_KEYS = {
    title: '.product__title__wrapper',
    rating: '.loox-rating, [class*="loox-rating"]',
    klarna: '[data-kv-test="T05"]',
    price: '.price-wrapper',
    tabs: '.kv-variant-tabs-outer:not(.kv-all-varaint-selector)',
    swatches: '.kv-all-varaint-selector',
    inventory: '.kv-inventory-block',
    shipping: '.product-info-block',
    discount: '.kv-discount',
    bundle: '[data-kv-test="T12"]',
    buy: 'product-form.product-form',
    returns: '.hassle-free-returns',
    payments: '.custom-payment-icons'
  };

  var PDP_MOVED = [];

  function pdpBlock(key) {
    var info = document.querySelector('.product__info-container');
    var sel = PDP_KEYS[key];
    if (!info || !sel) return null;
    var node = info.querySelector(sel);
    if (!node) return null;
    /* Walk up to the block wrapper that is a direct child of the column, so
       whole blocks move rather than the inner element on its own. */
    var column = info.querySelector('.product__info-column') || info;
    while (node && node.parentNode && node.parentNode !== column) {
      node = node.parentNode;
      if (node === document.body) return null;
    }
    return node;
  }

  function kvPdpReset() {
    for (var i = PDP_MOVED.length - 1; i >= 0; i--) {
      var entry = PDP_MOVED[i];
      if (entry.mark.parentNode) {
        entry.mark.parentNode.insertBefore(entry.node, entry.mark);
        entry.mark.parentNode.removeChild(entry.mark);
      }
    }
    PDP_MOVED = [];
  }

  function kvPdpOrder(keys) {
    if (!keys || !keys.length) return;
    kvPdpReset();
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var column = info.querySelector('.product__info-column') || info;
    var anchor = column.firstChild;
    keys.forEach(function (key) {
      var node = pdpBlock(key);
      if (!node || node === anchor) return;
      var mark = document.createComment('kv-pdp-' + key);
      node.parentNode.insertBefore(mark, node);
      PDP_MOVED.push({ node: node, mark: mark });
      column.insertBefore(node, anchor);
      anchor = node.nextSibling;
    });
  }

  window.kvPdpOrder = kvPdpOrder;
  window.kvPdpReset = kvPdpReset;

  /* Preset combinations, each its own arm. */
  var PDP_PRESETS = {
    'kv-t48': ['title', 'rating', 'klarna', 'price', 'tabs', 'swatches', 'shipping', 'buy'],
    'kv-t49': ['tabs', 'swatches', 'title', 'price', 'buy', 'rating', 'klarna', 'shipping'],
    'kv-t50': ['title', 'rating', 'price', 'tabs', 'swatches', 'buy', 'bundle', 'discount', 'shipping', 'klarna']
  };

  function pdpPresetSync() {
    var active = null;
    Object.keys(PDP_PRESETS).forEach(function (cls) {
      if (root.classList.contains(cls)) active = cls;
    });
    if (!active) {
      if (PDP_MOVED.length) kvPdpReset();
      return;
    }
    if (PDP_MOVED.length) return;
    kvPdpOrder(PDP_PRESETS[active]);
  }

  /* ---- Boot -------------------------------------------------------------- */
  function boot() {
    if (root.classList.contains('kv-t34') || root.classList.contains('kv-t35')) {
      galleries().forEach(buildGallery);
    }
    if (root.classList.contains('kv-t36')) {
      buildBuyBar();
    }
    if (root.classList.contains('kv-t40')) {
      galleries().forEach(buildFinderBadge);
    }
    measureNav();
    collapseEmptyBlocks();
    brandFinder();
    t47Sync();
    pdpPresetSync();
  }

  function run() {
    syncModes();
    boot();
  }

  run();
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(run);
  });
  window.addEventListener('load', run);
  window.addEventListener('resize', measureNav);
  window.addEventListener('resize', t47Sync);
  window.addEventListener('orientationchange', measureNav);
  window.setTimeout(run, 1200);

  /* Intelligems injects its stylesheet and variant JS late on some routes,
     and the theme re-inits the gallery when it crosses the 750px breakpoint,
     so keep watching the head and the class list. */
  new MutationObserver(run).observe(document.head, { childList: true });
  new MutationObserver(boot).observe(root, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('shopify:section:load', run);
})();
